import * as React from "react";
import RichTextEditor from "react-rte";
import { filterEditorState } from "draftjs-filters";

const BLOCKS = {
    unstyled: "P",
    "unordered-list-item": "UL",
    "header-one": "H1",
    "header-two": "H2",
    "header-three": "H3",
}

const BLOCKS_EXTENDED = {
    unstyled: "P",
    "unordered-list-item": "UL",
    "ordered-list-item": "OL",
    "header-one": "H1",
    "header-two": "H2",
    "header-three": "H3",
    "header-four": "H4",
    "header-five": "H5",
    "header-six": "H6",
    blockquote: "❝",
    "code-block": "{ }",
}

const STYLES = {
    BOLD: "B",
    ITALIC: "I",
}

const STYLES_EXTENDED = {
    BOLD: "B",
    ITALIC: "I",
    CODE: "`",
    STRIKETHROUGH: "~",
    UNDERLINE: "_",
}

const MAX_NESTING = 1;

const MAX_NESTING_EXTENDED = 4;

const ENTITIES = [
    {
        type: "LINK",
        label: "🔗",
        attributes: ["url"],
        whitelist: {
            href: "^(http:|https:|undefined$)",
        },
    },
    {
        type: "IMAGE",
        label: "📷",
        attributes: ["src"],
        whitelist: {
            src: "^http|./",
        },
    },
]

export interface IRTEFieldProps {
    name: string;
    value: string;
    onChange: (e: any) => void;
}

export class RTEField extends React.Component<IRTEFieldProps, any> {
    constructor(props: IRTEFieldProps) {
        super(props);
        this.state = {
            value: props.value ? RichTextEditor.createValueFromString(props.value, "html") : RichTextEditor.createEmptyValue()
        }
    }
    private onChange = (nextState: any) => {
        const { value } = this.state;
        const extended = true;
        let filteredState = nextState.getEditorState();
        const shouldFilterPaste =
            nextState.getEditorState().getCurrentContent() !== value.getEditorState().getCurrentContent() &&
            filteredState.getLastChangeType() === "insert-fragment"

        let html;
        if (shouldFilterPaste) {
            const filters = {
                blocks: Object.keys(extended ? BLOCKS_EXTENDED : BLOCKS),
                styles: Object.keys(extended ? STYLES_EXTENDED : STYLES),
                entities: ENTITIES,
                maxNesting: extended ? MAX_NESTING_EXTENDED : MAX_NESTING,
                whitespacedCharacters: ["\n", "\t", "📷"],
            }

            filteredState = filterEditorState(filters, filteredState);
            const newValue = RichTextEditor.EditorValue.createFromState(filteredState);
            html = newValue.toString("html");
            this.setState({ value: newValue });
        } else {
            html = nextState.toString("html");
            this.setState({ value: nextState });
        }
        if (this.props.onChange) {
            this.props.onChange({ target: { name: this.props.name, value: html } });
        }
    }
    static getDerivedStateFromProps(props: IRTEFieldProps, state: any) {
        if (state.value.toString("html") != props.value) {
            return {
                value: props.value ? RichTextEditor.createValueFromString(props.value, "html") : RichTextEditor.createEmptyValue()
            }
        } else {
            return state;
        }
    }
    static toolbarConfig = {
        extraProps: { tabIndex: -1 },
        // Optionally specify the groups to display (displayed in the order listed).
        // Reference:
        //  https://github.com/facebook/draft-js/blob/master/docs/Advanced-Topics-Custom-Block-Render.md#draft-default-block-render-map
        //  https://github.com/facebook/draft-js/blob/master/docs/Advanced-Topics-Inline-Styles.md
        display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
        INLINE_STYLE_BUTTONS: [
            { label: 'Bold', style: 'BOLD' },
            { label: 'Italic', style: 'ITALIC' },
            { label: 'Underline', style: 'UNDERLINE' }
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: 'Normal', style: 'unstyled' },
            { label: 'Heading Large', style: 'header-one' },
            { label: 'Heading Medium', style: 'header-two' },
            { label: 'Heading Small', style: 'header-three' },
            { label: 'Code Block', style: 'code-block' }
        ],
        BLOCK_TYPE_BUTTONS: [
            { label: 'UL', style: 'unordered-list-item' },
            { label: 'OL', style: 'ordered-list-item' },
            { label: 'Blockquote', style: 'blockquote' }
        ]
    };

    render(): JSX.Element {
        return <RichTextEditor value={this.state.value} toolbarConfig={RTEField.toolbarConfig} onChange={this.onChange} />
    }
}


// WEBPACK FOOTER //
// ./src/components/forms/rte-field.tsx